import { Switch, Redirect, Route, Link, Prompt, withRouter } from 'react-router-dom'

export { Switch, Redirect, Route, Link, Prompt, withRouter }



// WEBPACK FOOTER //
// ./src/router/index.js